import { render, staticRenderFns } from "./distributeDetail.vue?vue&type=template&id=006189a4&scoped=true"
import script from "./distributeDetail.vue?vue&type=script&lang=js"
export * from "./distributeDetail.vue?vue&type=script&lang=js"
import style0 from "./distributeDetail.vue?vue&type=style&index=0&id=006189a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006189a4",
  null
  
)

export default component.exports